module.exports = __webpack_public_path__ + "img/Gosia_Lewczuk.40695950.jpg";